<template>
    <g @click="crash" id="cactus_">
        <path id="cactus--border" fill="#FAD17F" d="M313,104.4c-5.8,0-10.4,4.7-10.4,10.4v4.2c0,1.3-1.1,2.4-2.4,2.4h-2.4v-15.3c0-0.3,0-0.6,0-0.8
	c0-0.1,0-0.1,0-0.2c0-0.2,0-0.4,0-0.6c0-0.1,0-0.2,0-0.3c0-0.2,0-0.3-0.1-0.5c0-0.1,0-0.3-0.1-0.4c0-0.1,0-0.3-0.1-0.4
	c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.3-0.1-0.4c0-0.1-0.1-0.2-0.1-0.3c0-0.2-0.1-0.3-0.2-0.5
	c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.2-0.1-0.3-0.2-0.5c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.1-0.3-0.2-0.5c0-0.1-0.1-0.1-0.1-0.2
	c-0.1-0.2-0.2-0.4-0.3-0.5c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.3-0.6c0,0,0-0.1-0.1-0.1c-0.1-0.2-0.2-0.4-0.4-0.6
	c0,0,0-0.1,0-0.1c-0.1-0.2-0.3-0.4-0.4-0.6c0,0,0,0,0-0.1c-0.1-0.2-0.3-0.4-0.4-0.6l0,0c-0.1-0.2-0.3-0.4-0.5-0.6c0,0,0,0,0,0
	c-0.2-0.2-0.3-0.4-0.5-0.6l0,0c-2.4-2.4-5.4-4-8.9-4.5l0,0c-0.3,0-0.5-0.1-0.8-0.1h0c-0.3,0-0.5,0-0.7-0.1c0,0,0,0-0.1,0
	c-0.3,0-0.6,0-0.8,0c0,0,0,0-0.1,0l0,0h0c-8.8,0-16,7.2-16,16v32.1h-2.4c-1.3,0-2.4-1.1-2.4-2.4v-16.8c0-5.7-4.7-10.4-10.4-10.4
	c-5.7,0-10.4,4.7-10.4,10.4v15.9c0,13.4,10.9,24.3,24.3,24.3h1.5v6.4h-7.4c-1,0-2.1,0.5-2.6,1.4c-0.6,0.9-0.7,2-0.3,3l3.2,8.5l0,0
	l0.1,0.2l7.3,19c0.5,1.2,1.7,2.1,3,2.1h12.8h12.8l0,0c0.2,0,0.3,0,0.5,0c0.1,0,0.1,0,0.2,0c1-0.2,1.9-1,2.3-2l4.9-12.7l0,0l0.5-1.4
	l5.2-13.5c0.3-0.7,0.3-1.5,0-2.3c-0.1-0.2-0.2-0.5-0.4-0.7c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.2-0.5-0.4-0.8-0.5
	c-0.1,0-0.2-0.1-0.4-0.1c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.5-0.1-0.8-0.1l0,0h-7.4v-23.2h1.5c13.4,0,24.3-10.9,24.3-24.3v-3.2
	C323.5,109.1,318.8,104.4,313,104.4z"/>
        <path id="cactus--left" fill="#63E340" d="M268.9,159h-4.7c-13.4,0-24.3-10.9-24.3-24.3v-15.9c0-5.7,4.7-10.4,10.4-10.4c5.7,0,10.4,4.7,10.4,10.4v16.8
	c0,1.3,1.1,2.4,2.4,2.4h5.6c1.8,0,3.2,1.4,3.2,3.2v14.5C272.1,157.6,270.7,159,268.9,159L268.9,159z"/>
        <path id="cactus--right" fill="#1CD46B" d="M299.2,142.3h-4.7c-1.8,0-3.2-1.4-3.2-3.2v-14.5c0-1.8,1.4-3.2,3.2-3.2h5.6c1.3,0,2.4-1.1,2.4-2.4v-4.2
	c0-5.8,4.7-10.4,10.4-10.4s10.4,4.7,10.4,10.4v3.2C323.5,131.4,312.6,142.3,299.2,142.3L299.2,142.3z"/>
        <path fill="#7CF55B" d="M294.6,171.9h-25.6c-1.8,0-3.2-1.4-3.2-3.2v-62.6c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16v62.6
	C297.8,170.4,296.3,171.9,294.6,171.9z"/>
        <path fill="#63E340" d="M281.8,90.1v81.8h12.8c1.8,0,3.2-1.4,3.2-3.2v-62.6C297.8,97.3,290.6,90.1,281.8,90.1L281.8,90.1z"/>
        <path fill="#63E340" d="M281.7,124.6c-1.8,0-3.2-1.4-3.2-3.2v-4.8c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2v4.8
	C284.9,123.1,283.5,124.6,281.7,124.6L281.7,124.6z"/>
        <path fill="#1CD46B" d="M281.8,113.4v11.2c1.8,0,3.2-1.4,3.2-3.2v-4.8C284.9,114.8,283.5,113.4,281.8,113.4z"/>
        <path fill="#63E340" d="M281.7,146.2c-1.8,0-3.2-1.4-3.2-3.2v-4.8c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2v4.8
	C284.9,144.8,283.5,146.2,281.7,146.2L281.7,146.2z"/>
        <path fill="#1CD46B" d="M281.8,135v11.2c1.8,0,3.2-1.4,3.2-3.2v-4.8C284.9,136.5,283.5,135,281.8,135L281.8,135z"/>
        <path fill="#BC6829" d="M294.6,199.5h-25.6c-1.3,0-2.5-0.8-3-2.1l-10.6-27.6c-0.4-1-0.3-2.1,0.3-3c0.6-0.9,1.6-1.4,2.6-1.4h46.9
	c1,0,2.1,0.5,2.6,1.4s0.7,2,0.3,3l-10.6,27.6C297.1,198.7,295.9,199.5,294.6,199.5L294.6,199.5z"/>
        <path fill="#B04617" d="M305.2,165.4h-23.4v34h12.8c1.3,0,2.5-0.8,3-2.1l10.6-27.6c0.4-1,0.3-2.1-0.3-3
	C307.2,166,306.2,165.4,305.2,165.4z"/>
        <path fill="#FFE89C" d="M302.4,184.7l2.5-6.4h-46.3l2.5,6.4H302.4z"/>
        <path fill="#FAD17F" d="M281.8,184.7h20.7l2.5-6.4h-23.1V184.7z"/>
        <path fill="#FAD17F" d="M300.5,202.2"/>
    </g>
</template>

<script>
    import { TimelineMax, Power0 } from 'gsap'

    export default {
        data: function () {
            return {
                tl: undefined,
                cactusKill: false
            }
        },
        mounted() {
            this.tl = new TimelineMax();
        },
        methods: {
            crash() {
                if (this.cactusKill == false) {
                    this.tl.set('#cactus--border', {opacity: 0});
                    this.tl.to('#cactus--left', 0.25, {x: -30, y: 50, ease: Power0.easeNone, rotation: -45});
                    this.tl.to('#cactus--left', 0.25, {x: -40, y: 92, ease: Power0.easeNone, rotation: -90});
                    this.tl.to('#cactus--right', 0.25, {x: +50, y: 50, ease: Power0.easeNone, rotation: +80}, '-=0.5');
                    this.tl.to('#cactus--right', 0.25, {x: +60, y: 60, ease: Power0.easeNone, rotation: +90}, '-=0.25');

                    this.cactusKill = true;
                }
            }
        }
    }
</script>

<style lang="scss">

    #cactus_ {

        &:hover #cactus--border{
            stroke: yellow;
            stroke-width: 5;
        }
    }

</style>
